import {useTheme} from '@mui/material';
import {SignInEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import React, {useEffect} from 'react';
import {useSearchParams, Navigate} from 'react-router-dom';
import {Loading} from 'presentation/components/Loading/Loading';
import {useAuthorization} from '../hooks/useAuthorization';

const {loading} = translations['pt-br'].commons;

function AuthorizationB2B() {
	const {palette} = useTheme();
	const {handleSetLoginToken} = useAuthorization();
	const [searchParams] = useSearchParams();
	const hash = searchParams.get('hash');

	useEffect(() => {
		if (hash) {
			handleSetLoginToken(hash);
		}
	}, [hash]);

	if (!hash) {
		return (
			<Navigate
				to={SignInEnum.LOGIN}
				state={{
					b2bError: true,
				}}
			/>
		);
	}

	return (
		<Loading
			text={loading}
			textColor={palette.other.progressBar}
			minHeight="100%"
			sx={{color: palette.other.progressBar}}
			thickness={6}
			boxProps={{
				bgcolor: palette.primary.main,
				minHeight: '100vh',
				justifyContent: 'center',
				position: 'fixed',
				zIndex: 9999,
				top: 0,
				left: 0,
			}}
		/>
	);
}

export {AuthorizationB2B};
